import * as ConstantRouter from '@/constant/router'

const route = {
  path: '/judge/:jsId?/login',
  name: ConstantRouter.JUDGE_LOGIN,
  component: () => import(/* webpackChunkName: "judge-login" */ '@/judge/login')
}

export default route
